// extracted by mini-css-extract-plugin
export default {"component":"xbDwL05k","logo":"hVZVsNTy","preloader":"hdxfoPvD","children":"ejdiLDfN","loading":"lUzUHprZ","loading-message":"x3uMsxps"};